<div class="login-page">
  <div class="login-card">
    <!-- Brand -->
    <div class="login-card__brand">
      <div class="login-card__mark">D</div>
      <span class="login-card__brand-name">Davaco</span>
    </div>

    <h1 class="login-card__title">Service Provider Directory</h1>
    <p class="login-card__subtitle">
      Secure access for Davaco staff and Service Provider teams. Choose your login method below.
    </p>

    <div class="login-card__actions">
      <button type="button" class="btn btn-primary btn-lg login-card__btn" (click)="signIn()">
        <app-icon name="building" [size]="16" />
        {{ authContext.kind === "auth0" ? "Sign in" : "Sign in with Davaco Account" }}
      </button>
    </div>

    <div class="login-card__foot">Internal tool — not for public distribution</div>
  </div>
</div>
